var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 4.86178C12.5937 5.12213 12.5937 5.54424 12.3333 5.80458L7.47138 10.9998C7.21103 11.2602 6.78892 11.2602 6.52858 10.9998L3.52858 7.99984C3.26823 7.73949 3.26823 7.31738 3.52858 7.05703C3.78892 6.79668 4.21103 6.79668 4.47138 7.05703L6.99998 9.58563L11.3905 4.86178C11.6509 4.60143 12.073 4.60143 12.3333 4.86178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6bb41bd975cbb842b59e86de16a9a779.svg";
export { ForwardRef as ReactComponent };